/* eslint-disable react/prop-types */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from 'react';
import { Storage } from 'aws-amplify';
import { CardContent, Typography, CardMedia, Box, Card, Button, TextField, Snackbar, Alert  } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { LinkButton } from '../../../../../components';
import { APP_ROUTES } from '../../../../../constants/app-routes';
import { cancelEventRegistration, createRefund } from '../../../../../core/vendor-events/action';
import { formatDate } from '../../../../../utils';
import { useStorageImage } from '../../../../../hooks/useStorageImage';

function CancellationConditions() {
  return (
    <Box>
      <Typography variant="body1" textAlign="justify" m={2}>
        You will receive a full refund if you cancel within 48 hours of confirmed payment.
        Otherwise, you will receive the full refund, minus cancellation fees.
      </Typography>
    </Box>
  );
}

function Refund({ setReason, setAmountRequested, setFile }) {
  const handleReasonChange = (event) => {
    setReason(event.target.value);
  };

  const handleAmountRequestedChange = (event) => {
    setAmountRequested(event.target.value);
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  return (
    <Box>
      <Typography variant="body1" textAlign="justify" m={2}>
        You will receive a full refund of your request.
      </Typography>
        <TextField
          label="Reason for the Refund"
          variant="outlined"
          fullWidth
          margin="normal"
          onChange={handleReasonChange}
        />
        <TextField
          label="Amount Requested"
          variant="outlined"
          fullWidth
          margin="normal"
          type="number"
          onChange={handleAmountRequestedChange}
        />
        <input
          type="file"
          accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
          onChange={handleFileChange}
        />
    </Box>
  );
}



export default function EventSection({ event }) {
  const [submit, isSubmit] = useState(false);
  const [reason, setReason] = useState('');
  const [amountRequested, setAmountRequested] = useState('');
  const [file, setFile] = useState(null);
  const parametersEvent = event.parameters_event ?? {};
  const [openSnack, setOpenSnack] = useState(false);
  const [snackMessage, setSnackMessage] = useState();
  const [snackAlert, setSnackAlert] = useState("info");
  const handleCloseSnack = (e, r) => {
    if (r === 'clickaway') {
      return;
    }
    setOpenSnack(false);
    setSnackMessage('');
  };

  const checkRefundTime = () => {
    if (parametersEvent.refund_deadline && parametersEvent.hour_refund_deadline) {
      const formattedDate = parametersEvent.refund_deadline.split('T')[0];
      const combinedDateTimeString = `${formattedDate}T${parametersEvent?.hour_refund_deadline}.000Z`;
      const currentDateTime = moment();
      const refundDateTime = moment.parseZone(combinedDateTimeString);
      const currentFormatted = currentDateTime.format('YYYY-MM-DDTHH:mm');
      const refundFormatted = refundDateTime.format('YYYY-MM-DDTHH:mm');
      const isAfterRefundTime = currentFormatted > refundFormatted;
      return isAfterRefundTime;
    }
    return false;
  };
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.users);
  const { refund, error } = useSelector((store) => store.vendorEvents);
  const photo = useStorageImage(event?.photo);

  useEffect(() => {
    if(refund === false && error){
      setOpenSnack(true)
      setSnackAlert("error")
      setSnackMessage(error.response.data.message.message)
    }
    if(refund === true){
      setOpenSnack(true)
      setSnackAlert("success")
      setSnackMessage('successful refund request')
    }
  }, [error, refund]);
  useEffect(() => {
    const fetchData = async () => {
      if (submit) {
        isSubmit(false)
        if (file) {
           try {
            const resultUpload = await Storage.put(
              `document_asset_${uuidv4()}_${file.name}`,
              file,
              {
                metadata: { name: `${file.name}` },
                level: 'public',
              },
            );
            if (resultUpload.key !== '') {
              dispatch(
                createRefund({
                  type_of_asset: 'document',
                  s3_object_key: resultUpload.key,
                  fk_user: user.id,
                  },
                  reason,amountRequested,event.id,user.id),
              )
            } 
          } catch (err) {
            console.log('Error uploading frontFile: ', err);
          } 
        } else {
          dispatch(
            createRefund(null,reason,amountRequested,event.id,user.id),
          )
        }
      }
    };
    fetchData();
  }, [submit, amountRequested, reason, file, event.id, user.id, user.cognito_id, dispatch]);
  

  if (!event.id) return null;
  const CustomSwal = withReactContent(Swal);
  const link = APP_ROUTES?.VENDOR_EVENT_GUIDE.replace(':id', event.id);

  const onCancelClick = () => {
    CustomSwal.fire({
      title: 'Are you sure to cancel this registration?',
      html: <CancellationConditions />,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d42d41',
      confirmButtonText: 'Yes, cancel it',
      cancelButtonText: 'Dismiss',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(cancelEventRegistration(event.id, user.id));
      }
    });
  };

  const onRefundClick = () => {
    CustomSwal.fire({
      title: 'Are you sure to refund money?',
      html: <Refund 
            setReason={setReason} 
            setAmountRequested={setAmountRequested} 
            setFile={setFile}
            reason={reason} 
            amountRequested={amountRequested} 
            file={file} 
          />,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d42d41',
      confirmButtonText: 'Yes, refund it',
      cancelButtonText: 'Dismiss',
    }).then((result) => {
      if (result.isConfirmed) {
        isSubmit(true)
      }
    });
  };

  return (
    <Card sx={{ display: 'flex', margin: '5px' }}>
      <Snackbar open={openSnack} autoHideDuration={5000} onClose={handleCloseSnack}>
        <Alert severity={snackAlert}>{snackMessage}</Alert>
      </Snackbar>
      <CardMedia
        component="img"
        sx={{ width: 151 }}
        image={photo}
        style={{ margin: '1rem' }}
        alt=""
      />
      <Box textAlign="left" width="100%">
        <CardContent>
          <Typography component="div" variant="h5">
            {event?.name}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div">
            {event?.street_address}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div">
            {formatDate(parametersEvent?.event_date, 'LL')}
          </Typography>
          <Typography variant="subtitle2" color="text.secondary" component="div">
            Cancellation available until {formatDate(parametersEvent?.cancellation_deadline, 'LL')}
          </Typography>
          {parametersEvent?.refund_deadline && (
            <Typography variant="subtitle2" color="text.secondary" component="div">
              Refund available until {formatDate(parametersEvent?.refund_deadline, 'LL')}{' '}
              {parametersEvent?.hour_refund_deadline}
            </Typography>
          )}
          <Box display="flex" width="100%" alignItems="center" gap={4}>
            <LinkButton to={link}>Go to event guide</LinkButton>
            <Button
              onClick={onCancelClick}
              disabled={moment().isSameOrAfter(moment(parametersEvent?.cancellation_deadline))}>
              CANCEL BOOKING
            </Button>
            {parametersEvent?.refund_deadline && (
            <Button
              type='button'
              onClick={onRefundClick}
              disabled={checkRefundTime()}>
              REFUND
            </Button>
            )}
          </Box>
        </CardContent>
      </Box>
    </Card>
  );
}

EventSection.propTypes = {
  event: PropTypes.instanceOf(Object),
};

EventSection.defaultProps = {
  event: {},
};
